import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Typography from '@mui/material/Typography';

type DealerSample = {
  id: string;
  label: string;
  phone: string;
  address: string;
  city: string;
  state: string;
  zipCode: string;
  email: string;
};

const DEALER_SAMPLES: DealerSample[] = [
  { id: 'dealer-001', label: 'Futura Trailers Inc.', phone: '(512) 555-0101', address: '1234 Trailer Blvd', city: 'Austin', state: 'TX', zipCode: '78701', email: 'sales@futuratrailers.com' },
  { id: 'dealer-002', label: 'Lone Star Haulers', phone: '(214) 555-0202', address: '567 Commerce Way', city: 'Dallas', state: 'TX', zipCode: '75201', email: 'info@lonestar haulers.com' },
  { id: 'dealer-003', label: 'Gulf Coast Cargo', phone: '(713) 555-0303', address: '890 Port Ave', city: 'Houston', state: 'TX', zipCode: '77001', email: 'hello@gulfcoastcargo.com' },
  { id: 'dealer-004', label: 'Southwest Transport Co.', phone: '(602) 555-0404', address: '321 Desert Road', city: 'Phoenix', state: 'AZ', zipCode: '85001', email: 'contact@swtransport.com' },
];

export default function DealerV2FormContainer() {
  const navigate = useNavigate();
  const [selected, setSelected] = useState<DealerSample | null>(null);
  const [error, setError] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!selected) {
      setError('Please select a dealer');
      return;
    }
    // TODO: wire up API call
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <h2 className="pb-2 mt-4 mb-3 border-bottom">Dealers</h2>
      <form noValidate onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12 }}>
            <Autocomplete
              options={DEALER_SAMPLES}
              value={selected}
              onChange={(_e, value) => {
                setSelected(value);
                setError('');
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Search"
                  variant="outlined"
                  autoFocus
                  error={Boolean(error)}
                  helperText={error}
                />
              )}
            />
          </Grid>
          {selected && (
            <Grid size={{ xs: 12 }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, mt: 1 }}>
                <Typography variant="body2"><strong>ID:</strong> {selected.id}</Typography>
                <Typography variant="body2"><strong>Company:</strong> {selected.label}</Typography>
                <Typography variant="body2"><strong>Phone:</strong> {selected.phone}</Typography>
                <Typography variant="body2"><strong>Email:</strong> {selected.email}</Typography>
                <Typography variant="body2"><strong>Address:</strong> {selected.address}, {selected.city}, {selected.state} {selected.zipCode}</Typography>
              </Box>
            </Grid>
          )}
          <Grid size={{ xs: 12 }}>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Button type="submit" variant="contained">Submit</Button>
              <Button variant="outlined" onClick={() => navigate('/dealers-v2')}>Cancel</Button>
            </Box>
          </Grid>
        </Grid>
      </form>
    </Container>
  );
}
